import React, { useState, useEffect, Fragment } from "react";
import {
  Card,
  Menu,
  Dropdown,
  Layout,
  Row,
  Col,
  Button,
  Modal,
  Input,
  Upload,
  Table,
  message,
  Select,
  DatePicker,
  Progress,
  Alert,
  Space,
  
} from "antd";
import { Link,useLocation } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import fileDownload from "js-file-download";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  ExportOutlined,
  FileSyncOutlined,
  PlusOutlined,
  ImportOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import "./BackupData.less";
import { values } from "underscore";

const { Search } = Input;
const { Content } = Layout;
const { Option } = Select;
function BackupData(props) {
  const [keyword, setKeyword] = useState("");
  const [date, setDate] = useState("");
  const [role, setRole] = useState([]);
  const [backupStatus, setBackupStatus] = useState(
    sessionStorage.getItem("backup_status") == "false" ? false:true
  );
  const [data, setData] = useState([]);
  const [backupDisabled, setDisabledBackup] = useState(false);
  const [downloadPercent, setDownloadPercent] = useState(0);
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [showProgress, setProgress] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPagesize] = useState(10);
  const [isModalVisible, setIsModalVisible] = useState(false);
   const [modalFailed, setFailedModal] = useState(0);
  const [sort, setSort] = useState({
    sort: "file_created_date",
    order: "desc",
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const search = queryParams.get('search');
  const getSessionBool = (key, fallback = false) => {
        const raw = sessionStorage.getItem(key);

        if (raw === null) {
          return fallback;
        }

        if (raw === "true") {
          return true;
        }

        if (raw === "false") {
          return false;
        }

      return fallback;
    };
  useEffect(() => {
    const interval = setInterval(() => {
      
      setBackupStatus(
        
        getSessionBool('backup_status')
      );
    }, 600);

    return () => clearInterval(interval);
  }, []);

  const handleSearch = (value) => {
    setKeyword(value);

  };
  const handleDate = (value) => {
    // alert(value)
    setDate(value);

  };

  const showTotal = (total) => {
    return `Found total ${total} record`;
  };

  useEffect(() => {
    getData();
  }, [keyword, page,category, sort,date,backupStatus]);

  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setPagesize(pagination.pageSize);
   
    setSort({
      sort: sorter.field,
      order: sorter.order,
    });
  };
  
  const closeModal = () => {
    setData({
      ...data,
      file: null,
    });
    setIsModalVisible(false);
  
  };
  const handleSelect = (value) => {
    setCategory(value)
  }
    const handleRemove = () => {
    setData({
      ...data,
      file: null,
    });
  };
    const handleBeforeUpload = (files) => {
    setData({
      ...data,
      file: files,
    });

    return false;
  };

  const onSaveData = () => {
    setLoading(true);

    let fd = new FormData();

    fd.append("file", data.file);

    Axios.post(`${url}/work-off-calendar/import`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.type == "warning") {
          message.warning(res.data.message);
        } else {
          message.success(res.data.message);
          closeModal();
        }
        getData();
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.data.type === "error") {
            message.error(err.response.data.message);
          } else {
            const errorsKey = Object.keys(err.response.data.errors);
            const errors = err.response.data.errors;

            message.open({
              message: `Error!: ${err.response.data.message}`,
              description: (
                <div>
                  Error Details:
                  {errorsKey.map((error) => {
                    return <div>{errors[error][0]}</div>;
                  })}
                </div>
              ),
            });
          }

          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        } else {
          message.error("Backend not yet Started");
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const getData = () => {
    setLoading(true);
    Axios.get(`${url}/system/backup-data`, {
      params: {
        keyword:keyword,
        category:category,
        columns: ["name","hash_md5"],
        perpage: 10,
        date: date,
        page,
        sort: sort.sort,
        order: sort.order,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setRole(res.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
   const showModal = () => {
    setIsModalVisible(true);
  };
  const handleBackup = () => {
  setLoading(true);
  sessionStorage.setItem('backup_status',true)
  Axios.post(
    `${url}/system/backup-now`,
    {},
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    }
  )
    .then((res) => {
      message.success(res.data.message || "Backup berhasil dijalankan");
      // kalau mau reload data, panggil fungsi fetch di sini
      // getData();
    })
    .catch((err) => {
      if (err.response) {
        message.error(err.response.data.message || "Backup gagal dijalankan");

        if (err.response.status === 401) {
          sessionStorage.removeItem("token");
        }
      } else {
        message.error("Tidak dapat terhubung ke server");
      }
    })
    .finally(() => {
      setLoading(false);
    });
};
  // const handleDownload = (id,name) => {
  //   setLoading(true);
  //   Axios.get(`${url}/system/backup-download/${id}`, {
  //     responseType: "blob",
  //     headers: {
  //       Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //     },
  //   })
  //     .then((res) => {
  //       // ambil nama file dari server
  //       let filename = name;

  //       const disposition = res.headers["content-disposition"];
  //       if (disposition && disposition.includes("filename=")) {
  //         filename = disposition.split("filename=")[1].replace(/"/g, "").trim();
  //       }

  //       // proses download file
  //       const urlBlob = window.URL.createObjectURL(new Blob([res.data]));
  //       const a = document.createElement("a");
  //       a.href = urlBlob;
  //       a.download = filename;
  //       a.click();

  //       window.URL.revokeObjectURL(urlBlob);
  //       setLoading(false);
  //       message.success("File berhasil diunduh");
  //     })
  //     .catch((err) => {
  //       if (err.response) {
  //         message.error(err.response.data.message || "Gagal mengunduh file");

  //         if (err.response.status === 401) {
  //           sessionStorage.removeItem("token");
  //         }
  //       } else {
  //         message.error("Terjadi kesalahan jaringan");
  //       }
  //       setLoading(false);
  //     });

  // };
const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure?",
      content: (
        <div>
          <p>Deleted data cannot be restored</p>
        </div>
      ),
      okText: "Delete",
      showCancel: true,
      onCancel: () => {
        return;
      },
      cancelText: "Cancel",
      confirmLoading: loading,
      onOk: async () => {
        confirmDelete(id);
      },
    });
  };
  const confirmDelete = (id) => {
     setLoading(true);
      Axios.get(`${url}/system/backup-delete/${id}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          message.success("File berhasil dihapus");
           setProgress(false)
           getData()
        })
        .catch((err) => {
          if (err.response) {
            message.error(err.response.data.message || "Gagal menghapus file");

            if (err.response.status === 401) {
              sessionStorage.removeItem("token");
            }
          } else {
            message.error("Terjadi kesalahan jaringan");
          }
          setLoading(false);
           setProgress(false)
          setDownloadPercent(0);
        });
    

  }
  const handleDownload = (id, name) => {
      setLoading(true);
      setDownloadPercent(0); // reset progress
      setProgress(true)
      Axios.get(`${url}/system/backup-download/${id}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setDownloadPercent(percent);
          }
        }
      })
        .then((res) => {
          // ambil nama file dari server
          let filename = name;

          const disposition = res.headers["content-disposition"];
          if (disposition && disposition.includes("filename=")) {
            filename = disposition.split("filename=")[1].replace(/"/g, "").trim();
          }

          // proses download file
          const urlBlob = window.URL.createObjectURL(new Blob([res.data]));
          const a = document.createElement("a");
          a.href = urlBlob;
          a.download = filename;
          a.click();

          window.URL.revokeObjectURL(urlBlob);
          setLoading(false);
          setDownloadPercent(100); // done
          message.success("File berhasil diunduh");
           setProgress(false)
        })
        .catch((err) => {
          if (err.response) {
            message.error(err.response.data.message || "Gagal mengunduh file");

            if (err.response.status === 401) {
              sessionStorage.removeItem("token");
            }
          } else {
            message.error("Terjadi kesalahan jaringan");
          }
          setLoading(false);
           setProgress(false)
          setDownloadPercent(0);
        });
    };


 
    const downloadTemplate = () => {
    Axios.get(`${url}/work-off-calendar/template`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      responseType: "blob",
    }).then((res) => {
      fileDownload(res.data, "Template Master Work Off Day" + ".xlsx");
    });
  };
  const columns = [
    {
      title: "Date Backup",
      dataIndex: "file_created_date",
      render:(data,row) => {
        return row.file_created_date;
      },
      sorter: true,
    },
    {
      title: "File",
      dataIndex: "name",
      sorter: true,
      render:(data,row) => {
        return row.name+" ("+row.file_size_mb+" MB)";
      },
    },
    // {
    //   title: "Path",
    //   dataIndex: "real_path",
    //   sorter: true,
    // },
    // {
    //   title: "Category",
    //   dataIndex: "category",
    //   sorter: true,
    // },
    // {
    //   title: "File Hash",
    //   dataIndex: "hash_md5",
    //   sorter: true,
    // },
    {
      title: "",
      dataIndex: "_id",
      align: "center",
      // sorter: true,
      // fixed: "right",
      width: 145,
      render: (id,data) => {
        return (
          <Fragment>
          
               <Button  style={{width:"100%"}} type="primary" onClick={() => handleDownload(id,data.name)}>
                      <DownloadOutlined />
                      Download
                    </Button>
              
           
            
          </Fragment>
        );
      },
    },
    {
      title: "",
      dataIndex: "_id",
      align: "center",
      // sorter: true,
      // fixed: "right",
      width: 145,
      render: (id,data) => {
        return (
          <Fragment>
            
               <Button  style={{width:"100%"}} type="default" danger onClick={() => handleDelete(id)}>
                      <DeleteOutlined />
                      Delete
                    </Button>
            
            
          </Fragment>
        );
      },
    },
  ];

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="Backup Data"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Modal
        title="Import Master Backup Data"
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
      >
        <Card className="body-data">
          <div name="control-hooks">
            <div name="file" label="File">
              <Fragment>
                <Upload
                  onRemove={handleRemove}
                  beforeUpload={handleBeforeUpload}
                  fileList={[]}
                >
                  <Button style={{ marginBottom: 10 }}>
                    Pilih File <ExportOutlined />
                  </Button>
                </Upload>
                {data.file && (
                  <React.Fragment
                    children={[
                      <Button onClick={handleRemove} type="danger" ghost>
                        <DeleteOutlined />
                      </Button>,
                    ]}
                  >
                    {data.file.name ? data.file.name : data.file}
                  </React.Fragment>
                )}
              </Fragment>
            </div>
            <div>
              <Button
                loading={loading}
                onClick={onSaveData}
                type="primary"
                htmlType="submit"
                className="mr-button"
                style={{
                  marginRight: 10,
                }}
              >
                Unggah
              </Button>
              <Button htmlType="reset" onClick={handleRemove}>
                Batal
              </Button>
            </div>
          </div>
        </Card>
      </Modal>
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              {backupStatus ? (<>
              <Alert message="Backup sedang diproses..." type="warning" showIcon />
              <br/>
              
              </>):""}
              
              <Row type="flex" gutter={[10, 20]} justify="space-around">
                <Col xs={24} md={16} lg={18}>
                 
                    <Button type="primary" disabled={backupStatus}  loading={loading} onClick={() => handleBackup()}>
                      <FileSyncOutlined />
                      Backup Now
                    </Button>
                </Col>
              
              
                <Col xs={24} md={4} lg={3} className="align-right">
                    <DatePicker  placeholder="Date Backup" onChange={(value) => handleDate(value)} />
                </Col>
                <Col xs={24} md={4} lg={3} className="align-right">
                 
                      <Search
                    placeholder="Search ..."
                    onSearch={(value) => handleSearch(value)}
                  />
                
                  
                </Col>

                {/* <Col xs={24}>
                 <Row>
                    <Col xs={24} md={3} style={{marginRight:10}}>
                    <label>Category</label>
                      <Select defaultValue="daily" onSelect={(value) =>  handleSelect(value)} style={{ width: "100%",marginRight:10 }}>
                            <Option value="hourly">Hourly</Option>
                            <Option value="daily">Daily</Option>
                            <Option value="weekly">Weekly</Option>
                          </Select>
                    </Col>
                    <Col xs={24} md={3}>
                    <label>Date Backup</label>
                    
                    </Col>
                    </Row>
                </Col> */}
            
                <Col xs={24}>
                  <Table
                  scroll={{ y: 500 }}
                    columns={columns}
                    dataSource={role.data}
                    rowKey={(data) => data._id}
                    onChange={handleTableChange}
                    pagination={{
                      pageSize: pageSize,
                      total: role.total,
                      showSizeChanger: true,
                      showTotal: showTotal,
                    }}
                    loading={loading}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
}

export default BackupData;
